/*  ========================================================================
    # Main JavaScript
    ========================================================================  */

import PageStatus from './scripts/page-status';
import Header from './scripts/header';
import OverlayHandling from './scripts/overlay-handling';
import AppointmentModal from './scripts/appointment-modal';

const scripts = [PageStatus, Header, OverlayHandling, AppointmentModal];

document.addEventListener('DOMContentLoaded', () => {
  if (scripts.length > 0 && scripts !== undefined) {
    scripts.forEach(script => {
      script.init();
    });
  }
});
